



























































import { Component, Vue, Watch } from "vue-property-decorator";
import {
  PolyDialogTypeInterface,
  MyTimetablesAddWeekOperationsInterface
} from "@/interfaces/index.ts";

import MenuOverlay from "@/components/MenuOverlay.vue";
import PolyDialog from "@/components/PolyDialog.vue";

@Component({
  components: {
    MenuOverlay,
    PolyDialog
  }
})
export default class MenuPage extends Vue {
  dialogType: PolyDialogTypeInterface = {};

  disableAddWeekButton: boolean = false;

  dataExists: boolean = false;

  menuDialog: boolean = false;
  menuDialogCheatCode: number = 0;

  dialog: boolean = false;
  dialogCheatCode: number = 0;

  currentRouteName: string = "home";
  currentRightButton: string = "refresh";

  inSettingsPage: boolean = false;

  DIALOG_OPEN_EVENT: string = "OPEN_DIALOG";
  ADD_WEEK_EVENT = "ADD_WEEK_OPS";
  RANDOMIZE_EVENT = "RANDOMIZE_EVENT";

  @Watch("menuDialog")
  onMenuOverlayChange(val: boolean): void {
    if (val) this.menuDialogCheatCode++;
  }

  @Watch("dialog")
  onDialogChange(val: boolean): void {
    if (val) this.dialogCheatCode++;
  }

  @Watch("$route")
  onRouteChange(to: any, from: any) {
    this.setIcons(to.name);
  }

  mounted() {
    this.initialiseCurrentRouteName();
    this.setUpWeekOpsListener();

    // @ts-ignore
    this.dataExists = this.$dataService.getCurrentTimetable().length > 0;

    this.$root.$on(
      this.DIALOG_OPEN_EVENT,
      (dialogType: PolyDialogTypeInterface) => {
        this.setDialogTypeAndOpenDialog(dialogType);
      }
    );

    this.setIcons(this.$route.name || "home");
  }

  setUpWeekOpsListener(): void {
    this.$root.$on(
      this.ADD_WEEK_EVENT,
      (weekOp: MyTimetablesAddWeekOperationsInterface) => {
        if (weekOp.activateButton !== undefined)
          this.disableAddWeekButton = weekOp.activateButton === false;
      }
    );
  }

  setIcons(currentRouteName: string): void {
    this.currentRightButton =
      currentRouteName === "myTimetables" ? "add" : "refresh";
    this.inSettingsPage = currentRouteName === "settings";
  }

  setDialogTypeAndOpenDialog(dialogType: PolyDialogTypeInterface): void {
    this.dialogType = dialogType;
    this.dialog = true;
  }

  rightHandMenuButtonClick(): void {
    if (this.currentRightButton === "add") this.sendAddWeekEvent();
    else this.sendRandomizeEvent();
  }

  sendAddWeekEvent(): void {
    const weekOp: MyTimetablesAddWeekOperationsInterface = {
      addWeek: true
    };

    this.$root.$emit(this.ADD_WEEK_EVENT, weekOp);
  }

  sendRandomizeEvent(): void {
    this.$root.$emit(this.RANDOMIZE_EVENT);
  }

  initialiseCurrentRouteName(): void {
    this.currentRouteName = this.$route.name as string;
  }

  openMenuOverlayWithCurrentPageName(): void {
    const currentRouteName = this.getCurrenRouteName();
    this.setCurrentRouteMenuOverlayObject(currentRouteName);

    this.menuDialog = true;
  }

  setCurrentRouteMenuOverlayObject(currentRouteName: string): void {
    this.currentRouteName = currentRouteName;
  }

  getCurrenRouteName(): string {
    const routeName: string = this.$route.name as string;
    return routeName;
  }

  openPage(page: string): void {
    this.dismissMenu();

    setTimeout(() => {
      this.$router.push({ name: page });
    }, 100);
  }

  dismissMenu(): void {
    this.menuDialog = false;
  }

  dismissedDialogWithData(data: PolyDialogTypeInterface): void {
    if (data && data.pageEvent) this.$root.$emit(data.pageEvent, data);

    this.dismissDialog();
  }

  beforeDestroy() {
    // this.$root.$off(this.DIALOG_OPEN_EVENT);
    // this.$root.$off(this.ADD_WEEK_EVENT);
    // this.$root.$off(this.RANDOMIZE_EVENT);
  }

  dismissDialog(): void {
    this.dialog = false;
  }
}
